exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n  /*\n    #sidebar {\n        margin-left: -250px;\n    }\n    #sidebar.active {\n        margin-left: 0;\n    }*/\n  /* TODO: Revisit responsiveness for the sidebar beyond the demo */\n.docm-col {\n    min-height: 300px;\n}\n}\n", ""]);

// exports
